import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../../common/constants';
import { createCapEndpointUrl } from '../../../../config';
import api from '../../../../api';
import { RootState } from '../../../../store';
import { ICapGroup } from '../listCap/listCapSlice';

export interface ICreateCapEndpointPayload {
  orgId: string;
  name: string;
  groups: ICapGroup[];
  templateId: number;
}

interface ICreateCapEndpointState {
  status: string;
  error: string | null;
  endpoint: any;
}

const initialState: ICreateCapEndpointState = {
  status: Status.IDLE,
  error: null,
  endpoint: null,
};

export const createCapEndpoint: any = createAsyncThunk(
  'createCapEndpoint',
  async (payload: ICreateCapEndpointPayload, { rejectWithValue }) => {
    try {
      const response = await api.post(createCapEndpointUrl, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const createCapEndpointSlice = createSlice({
  name: 'createCapEndpoint',
  initialState,
  reducers: {
    resetCreateCapEndpointStatus: (state) => {
      state.status = Status.IDLE;
      state.error = null;
      state.endpoint = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCapEndpoint.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(createCapEndpoint.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.endpoint = action.payload?.message ?? null;
      })
      .addCase(createCapEndpoint.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.createCapEndpoint;
export const { resetCreateCapEndpointStatus } = createCapEndpointSlice.actions;
export default createCapEndpointSlice.reducer;
